<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="60px">
				<el-row>
					<el-col :span="3">
						<el-form-item label="班级">
							<el-autocomplete class="inline-input" v-model="searchParams.clz"
								:fetch-suggestions="querySearch" placeholder="请输入班级名称"
								@select="handleSelect"></el-autocomplete>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="学生">
							<div v-if="stuList.length > 0"
								style="display: flex;margin-top:4px; margin-left:10px">

								<el-button type="success" :disabled="stuIdx == 0" size="mini"
									@click="naviStu(-1)">《《</el-button>
								<el-select @change="list" v-model="searchParams.snm" placeholder="请选择">
									<el-option v-for="item in stuList" :key="item" :label="item"
										:value="item">
									</el-option>
								</el-select>
								<el-button type="success" :disabled="stuIdx == (stuList.length - 1)"
									size="mini" @click="naviStu(1)">》》
								</el-button>
							</div>
							<el-input v-else placeholder="学生" v-model="searchParams.snm">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="图表高">
							<el-select v-model="activeCss" placeholder="请选择">
								<el-option
									v-for="val in ['系统默认', 300,310,320, 330, 340,  350,360, 370,380, 390,400]"
									:key="'vx' + val" :label="val" :value="val">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="2">

						<el-button type="primary" @click="print">打印</el-button>
					</el-col>
				</el-row>
			</el-form>
		</div>

		<!-- class="width:794px;height:1123px;background-color:'yellow'" -->
		<div id="printContent" v-if="listData">
			<div class="cp-content-body">
				<img src="../../../assets/img/copyright.png" class="copyright" alt="">
				<div class="dataTable autoFlex" if="searchParams.tnm == 1">
					<el-row>
						<el-col :span="24">
							<br><br>
							<div id="rpt1" style="width: 600px;">请先预览再手动设置相应的-图表高</div>
						</el-col>
					</el-row>
				</div>
				<div>
					<el-table class="table" style="width:700px" :show-header="false" stripe :data="modelData"
						border v-loading="listLoading">

						<!--el-table-column prop="title" width="70" label="分类模块">
							<template slot-scope="scope">
								<span style="font-size: 12px" align="center"> {{ scope.row.title }}
								</span>
							</template>
						</el-table-column -->
						<el-table-column prop="title" width="60" label="分类模块">
							<template slot-scope="scope">

								<el-tag size="mini" type="danger">{{ scope.row.val }}%</el-tag>
								<el-tag size="mini" type="warning">{{ scope.row.cnt }}题</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="descb" width="380px" label="分类模块综评">
							<template slot-scope="scope">
								<span style="font-size: 12px;" v-html="scope.row.descb"> </span>
							</template>
						</el-table-column>
						<el-table-column prop="descb" label="成绩差图表">
							<template slot-scope="scope">
								<div style="width: 100%;">
									<div v-for="v in scope.row.itms" :key="v.id" :id="v.id"
										style="width: 33%;height:45px;float: left;">
										{{ v.id }}
									</div>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div>
					<el-row>
						<el-col :span="24">
							<div style="width:600px; ">
								<br>
								<H4> 测评结论:</H4><br>
								<div v-html="result" style="line-height: 1.8;font-size: 12px;"></div>
							</div>
						</el-col>
					</el-row>
				</div>
				<div>
					<el-row>
						<el-col :span="24">
							<div
								style="width:600px; height: 100px; margin-right: 20px;display: flex;justify-content: flex-end;position: relative;">
								<img src="../../../assets/img/2.png" class="gz" alt="">
								<br> <br> 报告日期: {{ now }}
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<div class="dataTable autoFlex" v-else>
			<el-row>
				<el-col :span="24" id="rpt1_p">
					<div id="rpt1" style="width:88%;height: 500px;">准备显示..</div>
				</el-col>
			</el-row>
		</div>

	</div>

</template>
<script>


import api from '@/api/exams/exams/rpt_answers.js';
import subStu from "@/api/stus/student/student.js";
import * as echarts from 'echarts';
import apiClazz from '@/api/edu/clazz/clazz.js';

import exportPDF from "@/util/export-pdf"


export default {
	name: 'rptAnswers',
	components: {
		echarts
	},
	watch: {
		'searchParams.clz': {
			handler(newVal) {
				if (!newVal) {
					this.searchParams.exm = ''
				}
			},
			deep: true
		}
	},
	data() {
		return {
			searchParams: { tnm: 1 },
			listLoading: false,
			listData: [],

			activeCss: '系统默认',

			modelData: [{ "cnt": "131", "descb": "前端技术中掌握得较差的是<b style='color:#FF3300'>[node.js]</b>、<b style='color:#FF66CC'>[互联网基础与http协议]</b>、<b style='color:#FFCCCC'>[JavaScript编程-ES6]</b>,未及格的是<b style='color:#CCCC00'>[Ps切图制作静态页综合项目]</b>。掌握得比较好的是[CSS3样式与Web布局]、[JavaScript基础]", "itms": [{ "css": "#FF3300", "id": "A0", "sc": "20" }, { "css": "#FF66CC", "id": "A1", "sc": "25" }, { "css": "#FFCCCC", "id": "A2", "sc": "41" }, { "css": "#CCCC00", "id": "A5", "sc": "50" }], "title": "前端", "val": "44" },
			{ title: '后端', val: 48, descb: "个梵蒂冈电饭锅收到", itms: [{ id: 'C1', css: '#FF3300', sc: 65 }, { id: 'C11', css: '#FF33FF', sc: 49 }] },
			{ title: '数据库', val: 78, descb: "静态数据，如果显示高度要调整就刷新页面第一个选择那个学生", itms: [] }],

			result: '',

			stuList: [],
			stuIdx: 0,       //当前显示的学生
			clzList: null,  //备选班级

			now: '',

			echart1: {},     //图表-模块成绩柱状图
			option: {
				title: {
					text: '',
					left: 'center',
					textStyle: {
						fontFamily: '楷体',
						fontSize: 32,
						color: '#FF0000'
					}
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				legend: {},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				xAxis: {
					type: 'value',
					boundaryGap: [0, 0.01],
					max: 100
				},
				yAxis: {
					type: 'category',
					//data: ['前端基础[156题]', 'Java核心编程', '数据库开发', 'JavaWeb开发',
					//	'前端框架', 'Java开源框架', 'SpringCloud微服务[156题]', '软件工程', '项目开发阶段']
				},
				series: [
					{
						name: '',
						type: 'bar',
						itemStyle: {
							normal: {
								label: {
									show: true, //开启显示
									textStyle: { //数值样式
										color: "#fff",
										fontSize: 8,
										fontWeight: 150
									}
								},
								//可以设置每个柱上方显示数字
								color: function (params) {//柱状图设置不同颜色
									// 给出颜色组
									if (params.data < 60) {
										return "#ee6767";
									} else if (params.data < 75) {
										return "#4a77dd";
									} else if (params.data < 85) {
										return "#fac859";
									} else {
										return "#92cc76";
									}
								},
							}
						}
					},
				]
			}
		};
	},
	methods: {
		print() {
			exportPDF.exportPdf("printContent", this.searchParams.snm + this.now + ".pdf")
		},
		naviStu(val) {
			//学生导航
			if (val) {
				this.stuIdx += val
			}
			this.searchParams.snm = this.stuList[this.stuIdx]
			this.list()
		},
		// 备选班级
		querySearch(queryString, cb) {
			// console.log("this.clzList",this.clzList)
			if (this.clzList) {
				cb(this.clzList);
			}
		},
		// 选中班级
		handleSelect(item) {
			//console.log("选中班级",item)
			this.loadStu()
		},
		loadStu() {
			//console.log("失去焦点" )
			subStu.stuInClass2({ cname: this.searchParams.clz }, res => {
				this.stuList = res.data
				this.stuList.splice(0, 0, "请选择");
				//如果有学生
				if (this.stuList && this.stuList.length > 0) {
					//默认查询第一个学生
					this.searchParams.snm = this.stuList[0]
					//this.list()
				} else {
					this.searchParams.snm = null
					this.listData = {};
				}
			})
		},

		//获取答题数据
		list() {
			if (this.searchParams.snm != "请选择") {
				this.getOption(this.searchParams.clz)
			}

			//[{ title: '前端', val: 35, descbs: [{descb:"前端技术中较差的科目是：ES6、基本变量、node.js编程，掌握的有待提升的是Vue2、javaScript编程，总体评价为: 【待提升】",
			//            itms:[ {id:'A1'},{id:'A11'},{id:'A111'} ]}] },

		}, getOption(clznm) {
			//后端取图表数据
			api.examReport({ clznm: clznm, stunm: this.searchParams.snm }, res => {

				this.option.title.text = 'AI开发岗技能测评报告'

				//绘制饼图
				this.modelData = res.data.rptVos

				this.option.yAxis.data = res.data.models.yAxisData
				this.option.series[0].data = res.data.models.seriesData

				//this.option.series[0].name = "统计样本（只取最后一次）" + res.data.cntAll
				this.kidList = res.data.models.kidList
				this.echart1 = {}
				//渲染图表
				let rpt1 = document.getElementById("rpt1")

				if (this.activeCss == '系统默认') {
					if (this.modelData.length == 5) {
						this.activeCss = 330
					} else {
						this.activeCss = 300
					}
				}

				rpt1.style.height = this.activeCss + "px";

				this.$forceUpdate();

				this.echart1 = echarts.init(rpt1)
				//渲染数据->图表
				this.echart1.setOption(this.option)

				//结论
				this.result = res.data.result

				setTimeout(() => {
					//静态绘制子项
					this.modelData.forEach(itm => {

						itm.itms.forEach(v => {
							// 动态获取饼图的id
							let rpt = document.getElementById(v.id)
							//console.log("v.id", v.id, rpt)
							//渲染图表
							let echart = echarts.init(rpt)

							let data = {
								/*title: {
									subtext: v.nm,
									left: 'center',
									top: '-12%',
									subtextStyle: {
										fontSize: '12px',
										color: '#CC6666'
									}
								},*/
								series: [
									{
										name: 'Access From',
										type: 'pie',
										radius: '95%',

										itemStyle: {
											color: function (params) {
												var colors = [v.css, '#CCCCCC',];
												return colors[params.dataIndex];
											}
										},
										data: [
											{ value: v.sc, name: v.sc + '' },
											{ value: 100 - v.sc, name: '' },
										],

										label: {
											show: true, // 确保标签显示
											position: 'inside', // 或者 'inside', 'top', 'bottom', 'left', 'right' 等
											fontSize: '9px',
											color: '#FFF'
										}
									}
								]
							};
							//渲染数据->图表
							echart.setOption(data)
						})
					})
				}, 100)

			})
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
			this.searchParams.tnm = 0
			this.stuList = []
			this.list();
		},
	},
	mounted() {

		if (!this.clzList) {
			//加载一个
			apiClazz.listNoEnd(null, res => {
				this.clzList = res.data
				//尝试前段缓存取   dftClzNm
				let dftClzNm = this.$caches.dftClzNm.get("dftClzNm");
				if (dftClzNm) {
					this.$set(this.searchParams, 'clz', dftClzNm)
					this.loadStu()
				}
			})

		}

		this.now = new Date().format("yyyy-MM-dd");
		//this.list();
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';



#printContent {
	width: 794px;
	background-image: url(../../../assets/img/border-bg.jpg);
	height: 1155px;
	display: flex;
	align-content: center;
	justify-content: center;
}

.cp-content-body {

	padding: 25px;
	box-sizing: border-box;
	width: 794px;
	height: 1155px;
	background-color: white;
	background-clip: content-box;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	position: relative;
}

.gz {
	height: 144px;
	width: 200px;
	position: absolute;
	bottom: 15px;
}

.copyright {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 99;
	width: 100%;
	opacity: 0.1;
}
</style>
